import React from "react";

import "./Links.scss";
import { Link } from "../Link";

export type SocialProps = {
  cx?: string;
  list: { link: string; text: string }[];
  routerLink: any;
};

export const Links: React.FC<SocialProps> = ({ cx = "", list, routerLink }) => {
  return (
    <ul className={`Links ${cx}`}>
      {list.map(({ link, text }, idx) => (
        <li key={`${text}-${idx}`}>
          <Link to={link} routerLink={routerLink}>
            {text}
          </Link>
        </li>
      ))}
    </ul>
  );
};
